export default __webpack_public_path__ + "5af0f358b375a472892e1fd7ed6c6e5d.svg";